module.exports = __webpack_public_path__ + "cc881a56eb9c4414c21d06bd570bf93f.png";